// extracted by mini-css-extract-plugin
export default {"Wrapper":"PageEditionUtilisateur_Wrapper__BLb4D","Formulaire":"PageEditionUtilisateur_Formulaire__ULCwA","Explications":"PageEditionUtilisateur_Explications__J-aOf"};